module.exports = __webpack_public_path__ + "static/media/editDocument.f1a8501f.svg";